import { SEND_NOTIFICATION, DISMISS_NOTIFICATION } from "../actions";
import initialState from "./initialState";
import uuid from "../utils/uuid";
export default function notifications() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.notifications, action = arguments.length > 1 ? arguments[1] : void 0;
    var nState = state.slice();
    switch(action.type){
        case SEND_NOTIFICATION:
            var _n = {
                id: uuid(),
                key: action.key || "",
                seen: false,
                timestamp: new Date(),
                message: action.message,
                type: action.notificationType || "info",
                messageProps: action.messageProps || {},
                label: action.label || "",
                timeout: action.timeout
            };
            if (!_n.key.length || !nState.find(function(n) {
                return n.key === _n.key && !n.seen;
            })) {
                nState.push(_n);
            }
            return nState;
        case DISMISS_NOTIFICATION:
            var _state = state.slice();
            var n = _state.find(function(_n) {
                return _n.id === action.id;
            });
            if (n) {
                n.seen = true;
            }
            return n ? _state : state;
        default:
            return state;
    }
}
